import RewardStatusComponent from "../../Component/IncomeReport/RewardStatusComponent"

const RewardStatus = () => {
  return (
    <div className='page-body'>
      <RewardStatusComponent />
    </div>
  )
}

export default RewardStatus